import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Location, isPlatformBrowser } from '@angular/common';
import { LoadingSpinnerService } from './loadingSpinner.service';


@Injectable()
export class StartupService {
    private restaurantURL: String;

    constructor(
        private location: Location,
        private loadingSpinnerService: LoadingSpinnerService,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {}

    getRestaurantURL() {
        // Location.path() é server-safe (o platform-server semeia a URL do render);
        // no server extraímos o slug só dele. window.location/hostname/spinner Ionic
        // são browser-only e ficam sob guard (ver plano SSR/prerender).
        this.restaurantURL = this.location.path()?.split('/')[1]?.split('?')[0];

        if (!isPlatformBrowser(this.platformId)) {
            return this.restaurantURL;
        }

        this.loadingSpinnerService.present();

        if(window.location.href.includes('#!')){
            let url_parts = window.location.href.split('/');
            this.restaurantURL = url_parts[url_parts.length - 1];
        }

        if(location.hostname === 'localhost'){
            return this.restaurantURL;
        }

        if(typeof this.restaurantURL === 'undefined'){
            // window.location.replace("https://multipedidos.com.br");
        }

        return this.restaurantURL;
    }
}
